import { LanguageModel } from '../types/LanguageModel';

export const LanguageKz: LanguageModel = {
    login: 'Логин',
    password: 'Пароль',
    enter: 'Войти',
    welcome: 'Добро пожаловать!',
    exit: 'Выход',
    search: 'Найти...',
    accept: 'Подтвердить',
    comment: 'Комментарий',
    clear: 'Очистить',
    success: 'Успешно',
    error: 'Ошибка',
    loading: 'Идет загрузка',
    yes: 'Да',
    no: 'Нет',
    refuse: 'Отказать',
    cancel: 'Отменить',
    apply: 'Применить',
    users: 'Пользователи',
    back: 'Назад',
    filter: 'Фильтр',
    version: 'Версия',
    edit: 'Редактировать',
    nameRu: 'Название (RU)',
    nameKz: 'Название (KZ)',
    coordinates: 'Координаты',
    devices: 'Устройства',
    groupsDevices: 'Группы',
    apps: 'Приложения',
    messages: 'Мессенджер',
    map: 'Карта',
    configurations: 'Конфигурации',
    faq: 'Справка',
    organizations: 'Организации',
    admins: 'Администраторы',
    fillRequireField: 'Поле обязательное для заполнения',
    fieldNotANumber: 'Значение не является числом',
    authError: 'Неверные логин или пароль',
    adminPanel: 'Администраторская панель',
    firstName: 'Имя',
    changePassword: 'Сменить пароль',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    account: 'Аккаунт',
    areYouSure: 'Вы уверены?',
    areYouSureDeleteUser: 'Вы действительно хотете удалить пользователя?',
    // deleteUser: 'Удалить пользователя',
    passwordWasChange: 'Пароль был успешно изменен',
    serverError: 'Ошибка сервера, сообщите тех.поддежке и попробуйте позже',
    userWasChange: 'Информация была успешно изменена',
    addUser: 'Добавить пользователя',
    userWasAdd: 'Пользователь успешно добавлен в систему',
    userWasDelete: 'Пользователь успешно удален',
    addOrganization: 'Добавить организацию',
    admin: 'Администратор',
    organization: 'Организация',
    name: 'Название',
    description: 'Описание',
    phone: 'Телефон',
    email: 'E-Mail',
    address: 'Адрес',
    save: 'Сохранить',
    areYouSureDeleteOrganization:
        'Вы действительно хотете удалить организацию и все связанную с ней информацию?',
    deleteOrganization: 'Удалить организацию',
    managers: 'Менеджеры организаций',
    BIN: 'БИН',
    licence: 'Лицензии',
    until: 'До',
    unknown: 'Неизвестно',
    activeUntil: 'Активен',
    onSuspentOrganization: 'Восстановить работу',
    offSuspentOrganization: 'Приостановить работу',
    enterLabel: 'Вход',
    dashboard: 'Дашборд',
    organizationAuthError: 'Пользователь не привязан ни к одной из организаций',
    goToOrganization: 'Перейти к организации',
    mainPage: 'Главная',
    analytics: 'Аналитика',
    user: 'Пользователь',
    role: 'Роль',
    superAdmin: 'Суперадминистратор',
    operator: 'Оператор',
    subdivision: 'Подразделение',
    addGroup: 'Добавить группу',
    deleteGroup: 'Удалить группу',
    areYouSureDeleteGroup:
        'Вы действительно хотете удалить группу и все связанную с ней информацию?',
    countShort: 'шт.',
    fromPage: 'из',
    dateOnDevice: 'Дата вкл.',
    phoneModel: 'Модель',
    group: 'Группа',
    configuration: 'Конфигурация',
    launcherVersion: 'Версия',
    batteryLoad: 'Заряд',
    allGroups: 'Все группы',
    manager: 'Менеджер организации',
    permissionSettings: 'Настройки доступа',
    selected: 'Выбрано',
    settings: 'Настройки',
    settingsAll: 'Общие',
    settingsFunctions: 'Использование функций',
    settingsDesign: 'Дизайн',
    settingsApps: 'Приложения',
    settingsControl: 'Управление',
    delete: 'Удалить',
    addDevice: 'Добавить устройство',
    owner: 'Владелец',
    status: 'Статус',
    orderBy: 'Сортировать по',
    mainInfo: 'Общая информация',
    deviceData: 'Данные с устройства',
    files: 'Файлы',
    size: 'Размер',
    type: 'Тип',
    date: 'Дата',
    sendSms: 'Отправить SMS',
    block: 'Заблокировать',
    unblock: 'Разблокировать',
    deviceSaved: 'Данные об устройстве сохранены',
    packageId: 'ID пакета',
    weightApp: 'Размер',
    labelApp: 'Ярлык',
    pinApp: 'Закрепить',
    uploadDocument: 'Выберите или перетащите APK',
    uploadApk: 'Загрузить документ',
    wrongFileType: 'Фаил не является приложением .apk',
    basics: 'Основное',
    additionally: 'Дополнительно',
    permissions: 'Разрешения',
    restrictions: 'Ограничения',
    permissionAccept: 'Разрешено',
    permissionDenied: 'Запрет',
    gpsDescription: 'Определение местоположения',
    wifiDescription: 'Подключение к сети',
    bluetoothDescription: 'Передача файлов',
    internetDescription: 'Мобильная сеть',
    nfcDescription: 'Бесконтактная оплата',
    volume: 'Громкость',
    display: 'Экран',
    volumeDisable: 'Блокировка громкости',
    selectVolumeLevel: 'Выбрать уровень громкости',
    usbFilesUpload: 'Разрешение на передачу по USB',
    disableScreenshots: 'Запретить скриншоты',
    setTimeoutDisplay: 'Задать таймаут экрана',
    setBrightnessLevel: 'Задать уровень яркости',
    selectBrightness: 'Выбрать градацию',
    autoBrightness: 'Автоматическая яркость',
    smallIcon: 'Мелкие',
    mediumIcon: 'Средние',
    largeIcon: 'Большие',
    iconSize: 'Размер значков',
    orientation: 'Ориентация',
    rotateOrientation: 'Поворот',
    verticalOrientation: 'Вертикально',
    horizontalOrientation: 'Горизонтально',
    header: 'Заголовок',
    text: 'Текст',
    backgroundColor: 'Цвет фона',
    textColor: 'Цвет текста',
    timeZone: 'Часовой пояс',
    or: 'Или',
    load: 'Загрузить',
    parentGroup: 'Родительская группа',
    allDevices: 'Все устройства',
    unsorted: 'Несортированные',
    serial: 'Серия',
    performers: 'Сотрудники',
    iin: 'ИИН',
    events: 'События',
    device: 'Устройство',
    dictionary: 'Справочники',
    trademark: 'Модель производителя',
    workReason: 'Проводимые работы',
    carsCards: 'Карточки автомобилей',
    mark: 'Марка',
    model: 'Модель',
    color: 'Цвет',
    yearManufacture: 'Год выпуска',
    purpose: 'Назначение',
    state: 'Состояние',
    archive: 'Архив',
    reports: 'Отчеты',
    controls: 'Управление',
    maintenance: 'Тех. Обслуживание',
    from: 'От',
    to: 'До',
    autopark: 'Автопарк',
    drivers: 'Водители',
    dictionaries: 'Справочники',
    geozones: 'Геозоны',
    order: 'Приказы',
    active: 'Активна',
    stop: 'Приостановлено',

    department: 'Департамент по чрезвычайным ситуациям',
    jobTitleWasAdd: 'Должность успешно создана',
    jobTitleWasChange: 'Должность успешно обновлена',
    jobTitleWasDelete: 'Должность удалена',
    addJobTitle: 'Добавить должность',
    editJobTitle: 'Редактировать должность',
    editUser: 'Редактировать пользователя',
    jobTitles: 'Должности',
    jobTitle: 'Должность',
    personnelBase: 'Кадровая база',

    update: 'Обновить',
    code: 'Код',
    fio: 'Фио',
    FIO: 'ФИО',
    fired: 'Уволен',
    actions: 'Действия',
    registerUser: 'Зарегистрировать пользователя',

    cities: 'Города',
    city: 'Город',
    cityWasAdd: 'Город успешно добавлен',
    cityWasChange: 'Информация о городе успешно обновлен',
    cityWasDelete: 'Информация о городе удалена',
    addCity: 'Добавить город',
    editCity: 'Редактировать информацию о городе',
    latitude: 'Широта',
    longitude: 'Долгота',

    fireStationWasAdd: 'Пожарная станция успешно создана',
    fireStationWasChange: 'Пожарная станция успешно обновлена',
    fireStationWasDelete: 'Пожарная станция удалена',
    addFireStation: 'Добавить пожарную станцию',
    editFireStation: 'Редактировать пожарную станцию',
    fireStations: 'Пожарные станции',
    fireStation: 'Пожарная станция',

    fireFormationWasAdd: 'НГПС успешно создана',
    fireFormationWasChange: 'НГПС успешно обновлена',
    fireFormationWasDelete: 'НГПС удалена',
    addFireFormation: 'Добавить НГПС',
    editFireFormation: 'Редактировать НГПС',
    fireFormations: 'НГПС',
    fireFormation: 'НГПС',

    nightStayWasAdd: 'Ночное пребывание успешно создано',
    nightStayWasChange: 'Ночное пребывание успешно обновлено',
    nightStayWasDelete: 'Ночное пребывание удалено',
    addNightStay: 'Добавить ночное пребывание',
    editNightStay: 'Редактировать ночное пребывание',
    nightStays: 'Ночные пребывания',
    nightStay: 'Ночное пребывание',

    dispatcherWasAdd: 'Диспетчер успешно создан',
    dispatcherWasChange: 'Диспетчер успешно обновлен',
    dispatcherWasDelete: 'Диспетчер удален',
    addDispatcher: 'Создать диспетчера',
    editDispatcher: 'Редактировать диспетчера',
    dispatchers: 'Диспетчеры',
    dispatcher: 'Диспетчер',

    militaryNote: 'Строевая записка',
    operativeDepartment: 'Оперативный отдел',
    archiveDepartment: 'Архивный отдел',
    more: 'Подробнее',
    shift: 'Смена',

    fireDepartmentWasAdd: 'Пожарная часть успешно создана',
    fireDepartmentWasChange: 'Пожарная часть успешно обновлена',
    fireDepartmentWasDelete: 'Пожарная часть удалена',
    addFireDepartment: 'Добавить пожарную часть',
    editFireDepartment: 'Редактировать пожарную часть',
    fireDepartments: 'Пожарные части',
    fireDepartment: 'Пожарная часть',

    dutyServiceTsOUSS: 'Дежурная служба ЦОУСС',
    otherDutyServices: 'Прочие дежурные службы',
    shiftNumber: 'Номер смены',
    dutyOfficer: 'Оперативный дежурный',
    zamDutyOfficer: 'Зам. оперативного дежурного',
    pomDutyOfficer: 'Пом.оперативного дежурного',
    staffCar: 'Автомобиль штабной',
    dispatcherOne: 'Диспетчер 1',
    dispatcherTwo: 'Диспечер 2',
    radiotelephoneOperator: 'Радиотелефонист',
    dutyShiftDTSP: 'Дежурная смена ДТСП',
    dutyShiftTsOUSS: 'Дежурная смена ЦОУСС',
    dutyOfficers: 'Оперативные дежурные',
    dutyUKS: 'Дежурный УКС',
    dutyInvestigatorUCHS: 'Дежурный дознаватель УЧС',
    dutyGUWD: 'Дежурный ГУВД',
    operationalGuard: 'Оперативный постовой',
    taskForce: 'Оперативная группа',
    responsibleDuty: 'Ответств. дежурн. по гарнизону',
    other: 'Прочее',

    enterData: 'Введите название или выберите из списка',
    reset: 'Сбросить',
    passwordReset: 'сброс пароля',
    editData: 'Редактировать данные',
    employees: 'Сотрудники',
    employee: 'Сотрудник',
    searchFio: 'Поиск по ФИО',
    deleteUser: 'Удаление пользователя',
    deleteUsers: 'Удаление пользователей',
    areSureDeleteUser: 'Вы уверены, что хотите удалить этого сотрудника?',
    areSureDeleteUsers: 'Вы уверены, что хотите удалить этих сотрудников?',
    add: 'Добавить',
    hide: 'Скрыть',
    searchCity: 'Поиск города по коду или названию',
    deleteSelected: 'Удалить выбранное',
    areSureDeleteCity: 'Вы уверены, что хотите удалить этот город из таблицы?',
    listOfEquipment: 'Список техники',
    personnel: 'Персонал',

    codeCity: 'Код города',
    coordinatesCity: 'Координаты города',
    applyFilters: 'Применить фильтры',
    clearFilters: 'Очистить фильтры',

    // DVR
    appearance: 'Внешний вид',
    deviceName: 'Название устройства',
    deviceGroup: 'Группа устройства',
    cameraCount: 'Количество камер',
};
